<template>
  <v-card max-width="375" class="mx-auto" v-if="usuario">
    <v-img src="img/home.jpg" height="300px" dark>
      <v-row class="pa-5">
        <v-card-title>
          <!-- <v-btn dark icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn dark icon class="mr-4">
            <v-icon>mdi-pencil</v-icon>
          </v-btn> -->

          <!-- <v-btn dark icon>
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn> -->
        </v-card-title>
      </v-row>
      <v-col cols="12">
        <h2 class=" text-center white--text">
          {{ usuario.autor.nombres + " " + usuario.autor.apellidos }}
        </h2>
        <h4 class=" text-center white--text mt-1">
          Número IP {{ usuario.autor.ipName }}
        </h4>
      </v-col>
      
      <v-col cols="12" class="text-center">
        <div>
          <h4 class="white--text" v-if="usuario.autor.gestionSocioEstado">
            {{
              usuario.autor.memType.trim() == "SA"
              ? "SOCIO ACTIVO"
              : usuario.autor.memType.trim() == "AD"
              ? "ADMINISTRADO"
              : usuario.autor.memType.trim() == "RE"
              ? "REPRESENTADO"
              : ""
            }}
        </h4>
        <h4 class="white--text" v-if="usuario.autor.id == 102290 || usuario.autor.id == 104694 || usuario.autor.id == 108857">
          SUSPENDIDO
        </h4>
      </div>
      </v-col>
      <v-col cols="12">
        <h6
          class="white--text text-center"
          v-if="usuario.autor.gestionFechaIngreso"
        >
          desde el {{ usuario.autor.gestionFechaIngreso | dateFormat }}
        </h6>
      </v-col>
    </v-img>

    <v-list two-line>
      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">mdi-phone</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ usuario.celular }}</v-list-item-title>
          <v-list-item-subtitle>Celular</v-list-item-subtitle>
        </v-list-item-content>

        <!-- <v-list-item-icon>
          <v-icon>mdi-message-text</v-icon>
        </v-list-item-icon> -->
      </v-list-item>

      <!-- <v-list-item>
        <v-list-item-action></v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>(323) 555-6789</v-list-item-title>
          <v-list-item-subtitle>Work</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-icon>
          <v-icon>mdi-message-text</v-icon>
        </v-list-item-icon>
      </v-list-item> -->

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">mdi-account-box</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ usuario.username }}</v-list-item-title>
          <v-list-item-subtitle>Cédula de Identidad</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">mdi-email</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ usuario.email }}</v-list-item-title>
          <v-list-item-subtitle>Correo electrónico</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <!-- <v-list-item>
        <v-list-item-action></v-list-item-action>

        <v-list-item-content>
          <v-list-item-title>ali_connors@example.com</v-list-item-title>
          <v-list-item-subtitle>Work</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item> -->

      <v-divider inset></v-divider>

      <v-list-item>
        <v-list-item-icon>
          <v-icon color="primary">mdi-map-marker</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <p>{{ usuario.autor.direccion }}</p>
          <v-list-item-subtitle>Dirección</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-card>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
  data() {
    return {
      usuario: null,
    };
  },
  mounted() {
    axios
      .get("/miapa/miusuario")
      .then((response) => {
        console.log(response.data);
        this.usuario = response.data;
      })
      .catch((err) => {
        console.log(err);
      });
  },
  filters: {
    dateFormat(value) {
      if (value) {
        return moment(String(value))
          .locale("ES")
          .format("DD [de] MMMM [del] YYYY");
      }

      return "";
    },
  },
};
</script>
